import { createGlStore } from '../../group_leader/store/createGlStore'
import { wizardReducer } from './wizardSlice'

export const setupStore = (preloadedState) => createGlStore({ wizard: wizardReducer }, preloadedState)
